<template>
	<div class="h-[500px] w-full">
		<LMap
			ref="map"
			:zoom="zoom"
			:center="markerCoordinates"
			:use-global-leaflet="false"
		>
			<LTileLayer
				url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
				attribution='&amp;copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
				layer-type="base"
				name="OpenStreetMap"
			/>
			<LMarker :lat-lng="markerCoordinates" :title="title" :alt="title" />
		</LMap>
	</div>
</template>

<script setup>
import { ref } from 'vue'
const zoom = ref(15)
const markerCoordinates = ref([47.21322, -1.559482])
const title = ref('Propellerfestival')
const description = ref('')
const address =
	'Durrenberg, Deuchelried, Wangen im Allgäu, Verwaltungsgemeinschaft Wangen im Allgäu, Landkreis Ravensburg, Baden-Württemberg, 88239, Deutschland'

onMounted(() => {
	nextTick(async () => {
		const response = await fetch(
			`https://nominatim.openstreetmap.org/search?format=json&q=${address}`
		)
		const [result] = await response.json()
		console.log('result', result)
		if (result) {
			markerCoordinates.value = [result.lat, result.lon]
			description.value = result.display_name
		}
	})
})
</script>
